import { Chip } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import EventAvailableRoundedIcon from "@mui/icons-material/EventAvailableRounded";
import { colours } from "../../../StyleConstants";

interface ObjectStatus {
    label: string;
    fontColour: string;
    bgColour: string;
    icon: any;
}
export default function ValidationLabel(props: any) {
    const statusChip: Record<string, ObjectStatus> = {
        rejected: {
            label: "REJECTED",
            fontColour: colours.error.error,
            bgColour: colours.error.error20,
            icon: HighlightOffIcon,
        },
        approved: {
            label: "APPROVED",
            fontColour: colours.success.success,
            bgColour: colours.success.success20,
            icon: CheckIcon,
        },
        pending: {
            label: "PENDING",
            fontColour: colours.warning.warn,
            bgColour: colours.warning.warn20,
            icon: EventAvailableRoundedIcon,
        },
        default: {
            label: "DEFAULT",
            fontColour: colours.success.success,
            bgColour: colours.success.success20,
            icon: RotateLeftIcon,
        },
        completed: {
            label: "COMPLETED",
            fontColour: colours.success.success,
            bgColour: colours.success.success20,
            icon: CheckIcon,
        },
        notstarted: {
            label: "NOT STARTED",
            fontColour: colours.gray.gray70,
            bgColour: colours.gray.gray10,
            icon: HighlightOffIcon
        },
        revoked: {
            label: "REVOKED",
            fontColour: colours.error.error,
            bgColour: colours.error.error20,
            icon: HighlightOffIcon,
        },
        submitted: {
            label: "PENDING APPROVAL",
            fontColour: colours.warning.warn,
            bgColour: colours.warning.warn20,
            icon: RotateLeftIcon,
        },
        inprogress: {
            label: "PENDING APPROVAL",
            fontColour: colours.warning.warn,
            bgColour: colours.warning.warn20,
            icon: RotateLeftIcon,
        },
        traininginprogress: {
            label: "IN PROGRESS",
            fontColour: colours.warning.warn,
            bgColour: colours.warning.warn20,
            icon: RotateLeftIcon,
        },
        declined: {
            label: "DECLINED",
            fontColour: colours.error.error,
            bgColour: colours.error.error20,
            icon: RotateLeftIcon,
        },
        cancelled: {
            label: "CANCELLED",
            fontColour: colours.error.error,
            bgColour: colours.error.error20,
            icon: HighlightOffIcon,
        },

    };

    const statusInfo = statusChip[props.state] ?? statusChip.default;
    const styles = { color: statusInfo.fontColour };

    return (
        <>
            <Chip
                icon={<statusInfo.icon styles={styles} />}
                label={statusInfo.label}
                sx={{
                    backgroundColor: statusInfo.bgColour,
                    color: statusInfo.fontColour,
                    height: 22,
                    borderRadius: 24,
                    fontSize: 10,
                    borderWidth: 0,
                    fontWeight: "600",
                }}
            />
        </>
    );
}
